import React, { useEffect, useState } from 'react'
import { ICONS } from '../../constants/imageConstants'
import { cn } from '../../lib/utils'

const BaseModal = ({
  isOpen,
  onClose,
  children,
  title,
  subtitle,
  icon,
  iconBgColor,
  showCloseButton = true,
  closeOnBackdrop = true,
  maxWidth = 'max-w-sm',
  className = '',
  contentClassName = '',
  animate = true,
}) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
      if (animate) {
        const timer = setTimeout(() => setShow(true), 10)
        return () => clearTimeout(timer)
      } else {
        setShow(true)
      }
    } else {
      document.body.style.overflow = 'unset'
      setShow(false)
    }
    
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, animate])

  if (!isOpen) return null

  const handleBackdropClick = () => {
    if (closeOnBackdrop) {
      onClose()
    }
  }

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex items-center justify-center p-4 transition-all duration-300',
        show ? 'bg-gray-900/40 backdrop-blur-sm' : 'bg-transparent backdrop-blur-none',
      )}
      onClick={handleBackdropClick}
    >
      <div
        className={cn(
          'relative w-full bg-white rounded-2xl shadow-2xl transform transition-all duration-300 cubic-bezier(0.34, 1.56, 0.64, 1)',
          show ? 'scale-100 opacity-100 translate-y-0' : 'scale-95 opacity-0 translate-y-4',
          maxWidth,
          className
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 w-10 h-10 rounded-sm bg-gray-100 flex items-center justify-center transition-colors duration-200 text-gray-500 hover:text-gray-700"
            aria-label="Close modal"
          >
            <img src={ICONS.CLOSE} alt="Close" className="w-6 h-6" />
          </button>
        )}

        {(title || icon) && (
          <div className={cn('pt-8 px-8 pb-4 text-center', contentClassName)}>
            {icon && (
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-sm"
                style={{ backgroundColor: iconBgColor || '#ECFDF5' }}
              >
                {typeof icon === 'string' ? (
                  <img src={icon} alt="" className="w-8 h-8" />
                ) : (
                  icon
                )}
              </div>
            )}
            {title && (
              <h3 className="text-xl font-bold text-gray-900 mb-2 tracking-tight">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-gray-500 text-[15px] leading-relaxed">
                {subtitle}
              </p>
            )}
          </div>
        )}

        <div className={cn(!title && !icon ? 'p-6' : 'px-8 pb-8', contentClassName)}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default BaseModal